 var user_is_logged_in = false;

$(document).ready(function ($) {
    var is_mobile = $(window).width() > 992 ? false : true;
    var product_number = 0;
    var cart_product_number = 0;
    var cart_accessories = 0;
    var cart_count_items = 0;
    var tab_cart_by_collection = {};
    var tab_cart_accessory = {};


    /**
     * remove duplicate items in array
     *
     * @param {*} array
     * @returns
     */
    function removeDuplicates(array) {
        let unique = {};
        array.forEach(function(i) {
            if ( !unique[i] ) {
                unique[i] = true;
            }
        });
        
        return Object.keys(unique);
    }
    
    /**
     * format string by replacing all special characters by hyphens
     *
     * @param {string} inputString
     * @returns
     */
    function handleize(inputString) {
        outputString = inputString.replace(/([~!@#$%^&*()+=`{}\[\]\|\\:;'<>,.\/? ])+/g, '-').replace(/^(-)+|(-)+$/g,'').toLowerCase();
        return outputString;
    }
    
    //manage brands
    var wrapper_class = '';
    $('.sample_wrapper').each(function(){
        wrapper_class = $(this).data('class');
        displayItemsPartially(wrapper_class);
    });
    /**
     * Display item hidden items for block width show More button
     *
     * @param {*} wrapper_class
     */
    function displayItemsPartially(wrapper_class) {
        var brandItemCollection = $('.'+wrapper_class+' .hidden_sample .sample_item');
        var defaultItemNumber = '';
        var showAll = $('.'+wrapper_class).data('show-all');
        defaultItemNumber = parseInt($('.'+wrapper_class).attr('default-desktop-item-number'));
        //detect mobile phone and tablet
        if ( window.innerWidth <= 992 ) {
            defaultItemNumber = parseInt($('.'+wrapper_class).attr('default-mobile-item-number'));
        } 
        if(showAll == false){
            $('<ul class="visible_sample"></ul>').appendTo('.'+wrapper_class);
            var brandWrapper = $('.'+wrapper_class+' .visible_sample');
            if( brandItemCollection.length > defaultItemNumber ){
                $('#'+wrapper_class+' .load_more_sample').show();
            } else {
                $('#'+wrapper_class+' .load_more_sample').hide();
            }
        } else {
            $('#'+wrapper_class+' .load_more_sample').hide();
        }
        $.each(brandItemCollection, function (index, element) { 
            if(showAll == false) {
                if ( (brandItemCollection.length <= defaultItemNumber) || (brandItemCollection.length > defaultItemNumber
                    && index < defaultItemNumber) ) {
                    brandWrapper.append(element);
                } 
            }
            if(showAll == true) {
                $('.'+wrapper_class+'_button.hidden_sample').addClass('visible_sample').removeClass('hidden_sample');
            }
        });
        if(showAll == false)
            showMoreItems(brandWrapper, brandItemCollection, defaultItemNumber, wrapper_class);
    
        // if ( typeof(brands) != 'undefined' ) {
        //     displayBrandAphabetically();
        // }
        // displayBrandAphabetically();
    }
    
    //show more items
    function showMoreItems(brandWrapper, brandItemCollection, defaultItemNumber, wrapper_class) {
        var totalItemsAvailable = brandItemCollection.length - defaultItemNumber;
        var additionalItems = '';
        var lastItems = '';
        var brandItemCollection = brandItemCollection.toArray();
        var threshold = 30;
        $(document).on('click',  '#'+wrapper_class+' .load_more_sample:not(.show_more_brands)', function(){
            if (totalItemsAvailable >= threshold) {
                if (!(totalItemsAvailable % threshold)) {
                    additionalItems = threshold; 
                    totalItemsAvailable -= threshold;
                } else {
                    lastItems = totalItemsAvailable % threshold;
                    additionalItems = threshold;
                    totalItemsAvailable -= lastItems;
                }
            } else {
                additionalItems = totalItemsAvailable;
                totalItemsAvailable = 0;
            }
            if (totalItemsAvailable == 0) {
                $('#'+wrapper_class+' .load_more_sample').hide();
            }
            for (var index = defaultItemNumber; index <= (defaultItemNumber + additionalItems - 1); index++) {
                brandItemCollection[index].classList.add('additional_sample');
                brandWrapper.append(brandItemCollection[index]);
            } 
            //update index starter
            defaultItemNumber += additionalItems;             
        });
    }

    /**
     * display brand alphabetically
     *
     */
    function displayBrandAphabetically() {
        var tabBrandName = [];
        var tabLetters = []
        var tabUniqueLetters = [];

        //all brand
        for (key in brands) {
            tabBrandName[key] = brands[key]['title'];
            tabLetters[key] = tabBrandName[key].charAt(0);
            tabLetters.sort();
        }

        //unique elment
        for(i in tabLetters) {
            if(i == 0) {
                tabUniqueLetters.push(tabLetters[0]);
            }
            if(i > 0) {
                if(tabLetters[i - 1] !== tabLetters[i]){
                    tabUniqueLetters.push(tabLetters[i]);
                }   
            }
        }

        //character group
        for(k in tabUniqueLetters) {
            $('.sample_wrapper .first_letter_brand').append(
                '<li data-character-group='+tabUniqueLetters[k].toLowerCase()+'><span>'+tabUniqueLetters[k]+'</span></li>'
            );
        }

        //show items by character group
        $('.first_letter_brand li').click(function(){
            data_character = $(this).attr('data-character-group');
            $('.sample_item').hide();
            $('[data-character='+data_character+']').css("display", "flex");
        });
    
    }
    if ( !is_mobile ) {
        $('.gm-badge').closest('.gm-item').hide();
    }

    /* mobile accoridion */
    if ( is_mobile ) {
        $('.mobile-nav-wrapper .gm-badge').closest('.gm-item').addClass('customer_class');
        if ( user_is_logged_in ) {
            $($('.mobile-nav-wrapper .customer_class').eq(0)).hide();
        } else {
            $($('.mobile-nav-wrapper .customer_class').eq(1)).hide();
        }
        
    }

   

    //adding anchor on home slider  get started button
    $(document).on('click', '.slider .slider_text_get_started', function(e){
        $('html, body').animate({
            scrollTop: $('.product_type').offset().top
        }, 500);
    });

    //display overlay on menu hover
    $('.main_menu_item').on('mouseover mouseout', function(event) {
        if($(this).hasClass('site-nav--has-dropdown')) {
            if( event.type == 'mouseover' ) {
                displayOverlayBackground('show');
            }
            if( event.type == 'mouseout') {
                displayOverlayBackground('hide');
            }
        }  
    });

    $('.thecobblers_experience .has_popup').click(function(e){
        $(this).closest('li').find('.popup_wrapper').show();
    });
    // $(document).on('click', '.popup_wrapper .close', function(e){
    //     $(this).closest('.popup_wrapper').hide();  
    // }); 


    /** close popup */
    $(document).click(function (e) {
        if ($(e.target).is('.popup_wrapper:not(#shopping_cart_popup)')) {
            $(e.target).hide();
        }
    });

    //manage sub-menu in mobile
    $(window).load(function() {
        $('.gm-menu.gm-menu-mobile > .gm-item:not(.searchItem) .gm-text').click(function(e){ 
            e.preventDefault();
            e.stopPropagation();
            var href = $(this).closest('a').attr('href');
            location.replace(href);
        });
        $('.gm-menu.gm-menu-mobile > .gm-item:not(.searchItem) .gm-icon').click(function(e){
            e.preventDefault();
            e.stopPropagation();
            var sub_menu_wrapper = $(this).closest('li');
            if ( sub_menu_wrapper.hasClass('gm-active') ) {
                sub_menu_wrapper.removeClass('gm-active');
                $(this).addClass('fa-angle-down').removeClass('fa-angle-up');
            } else {
                sub_menu_wrapper.addClass('gm-active');
                $(this).removeClass('fa-angle-down').addClass('fa-angle-up');
            }
        });
    });
    

    /**
     * 
     * @param {*} display
     */
    function displayOverlayBackground(display){
        if( display == 'show' ) {
            $('#menu_overlay').css({'opacity': 0.5, 'z-index': 110, 'height': '100%'});
        }
        if( display == 'hide' ) {
            $('#menu_overlay').css({'z-index': -1});
        }
    }

    /**
     * sorted cart grouped by collection-value key
     *
     * @param {*} cart
     * @returns
     */
    function sorted_cart_items(tab_cart) {
        var tab_cart_item_by_collection = {};
        var collection_number = 0;
        var collection = ''
        var key = '';
            
        for ( t in tab_cart.items ) {
            if ( tab_cart.items[t].properties.hasOwnProperty('Collection') ) {
                collection = handleize(tab_cart.items[t].properties.Collection);
                collection_number = tab_cart.items[t].properties.Collection_number;
                key = collection + '-' + collection_number;

                if ( typeof(tab_cart_item_by_collection[collection]) === 'undefined' ) {
                    tab_cart_item_by_collection[collection] = {
                        number_of_shoe: parseInt(collection_number)
                    };
                }
                if ( typeof(tab_cart_item_by_collection[collection][key]) === 'undefined' ) {
                    tab_cart_item_by_collection[collection][key] = {
                        Collection: tab_cart.items[t].properties.Collection,
                        Collection_number: tab_cart.items[t].properties.Collection_number,
                        Type: tab_cart.items[t].properties.Type,
                        featured_image: tab_cart.attributes['image_'+collection],
                        Product_number: tab_cart.items[t].properties.Product_number,
                        items: []
                    };
                }
                
                tab_cart_item_by_collection[collection][key]['items'].push(tab_cart.items[t]);
            } 
        }

        return tab_cart_item_by_collection;
    }

    /**
     * Sorted accessories products from cart
     *
     * @param {*} cart
     * @returns
     */
    function sorted_accessories_items(tab_cart) {
        var tab_accessories_items = {
            items: []
        };
        for ( t in tab_cart.items ) {
            if ( tab_cart.items[t].properties.Type == "Accessory" ) {
                tab_accessories_items['items'].push(tab_cart.items[t]);
            } 
        }

        return tab_accessories_items;
    }

    tab_cart_collection = sorted_cart_items(tab_cart);
    tab_cart_accessory = sorted_accessories_items(tab_cart);

    /**
     * Count collection number in cart and accessories
     * 
     * @param {*} tab_cart_collection
     * @param {*} tab_cart_accessories
     * @returns
     */
    function count_product_number(tab_cart_collection, tab_cart_accessory) {
        cart_product_number = 0;
        cart_accessories = 0;

        if ( tab_cart.item_count > 0 ) {
            for ( collection in tab_cart_collection ) {
                for ( item in tab_cart_collection[collection] ) {
                    if ( item !== 'number_of_shoe' ) {
                        cart_product_number++;
                    }
                }
            }
        }

        if ( tab_cart_accessory.items.length > 0 ) {
            for ( item in tab_cart_accessory.items ) {
                cart_accessories++;
            }
        }

        return cart_product_number + cart_accessories;
    }

    cart_count_items = count_product_number(tab_cart_collection, tab_cart_accessory);
    $('#CartCount .item_count').text(cart_count_items);
    if ( cart_count_items = 0 ) {
        $('#CartCount').addClass('hide');
    }

    /** brand page get started button */
    $(document).on('click', '.single_brand_banner--button a', function(e){
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('.shoes_collections_type').offset().top
        }, 500);
    });
    
    //header padding
  	$(window).scroll(function(e) {
        $('header.site-header').css('margin-top', $('[data-section-id=header] .free_shipping_banner').outerHeight());
        $('[data-section-id=header] .free_shipping_banner').css('position', 'fixed');
    });

    /** Mega menu */
    $('.mobile-nav__icon').click(function(){
        var submenu = $(this).closest('li').find('.mobile-nav__dropdown');
        $('.mobile-nav__dropdown').hide();

        if (submenu.hasClass('open')) {
            submenu.hide().removeClass('open');
        } else {
            submenu.show().addClass('open');
        }
    });

    /** popup management */
    $('.has_popup').click(function(e) {
        e.stopPropagation();
        $('.'+$(this).attr('popup-selector')).show();
    });
    $('.popup_wrapper .fa-times').click(function(e) {
        $(this).parents('.popup_wrapper').hide(); 
    });

    /** FAQ */
    var faqQuestion = $('.faq_accordion .faq_question');    
    faqQuestion.click(function(event){
        let faqBody = $(this).next();
        $(this).toggleClass('active');
        faqBody.toggleClass('open');
        
        if (!faqBody.hasClass('open')) {
            faqBody.slideUp(300);
        } else {
            faqBody.slideDown(300);
        }
    });


    /** Business chat */
    window.IOSChat = window.IOSChat || {
    	
    };
    IOSChat.setup = (function() {
        var selectors = {
            $containerWrapper: $('.apple_business_chat'),
            $container: $('#popup_ios_chat'),
            $sendButton: $('#popup_ios_chat .send_button'),
            $closeButton: $('#popup_ios_chat .close_popup'),
            $chatBubble: $('.bubble_chat_ios'),
            $zendeskChat: '#launcher'
        };
      
      
        var sessionKey = 'popupHasBeenShowed';
        var hideZendeskChat = null;
        let utm_params = null;

        function init() {
            hideZendeskChat = setInterval(checkZendeskChat, 4000);
            close();
            showPopup();
            sendMessage();
            initUtm();
            setUtmParams();
        }

        function initUtm() {
            var params = new URLSearchParams(window.location.search);
            var url_utm_params = [];
            params.forEach(function (value, key) {
                if (key.startsWith('utm_')) {
                    url_utm_params.push(key + '=' + value);
                }
            })
            var utm_search = url_utm_params.join('&');
            if (utm_search) {
                localStorage.setItem('utm_params', utm_search);
                utm_params = utm_search;
            } else {
                utm_params = localStorage.getItem('utm_params');
            } 
        }

        function setUtmParams() {
            if (!utm_params) {
                selectors.$sendButton.attr('href', `${selectors.$sendButton.attr('href')}?biz-intent-id=thecobblerswebsite`);
                selectors.$chatBubble.find('.bubble_wrapper').attr('href', `${selectors.$chatBubble.find('.bubble_wrapper').attr('href')}?biz-intent-id=thecobblerswebsite`);
                return;
            }
            selectors.$sendButton.attr('href', `${selectors.$sendButton.attr('href')}?biz-intent-id=${utm_params}`);
            selectors.$chatBubble.find('.bubble_wrapper').attr('href', `${selectors.$chatBubble.find('.bubble_wrapper').attr('href')}?biz-intent-id=${utm_params}`);
        }

        function checkZendeskChat() {
            if ($(selectors.$zendeskChat).hasClass('is_hidden')) {
                clearInterval(hideZendeskChat);
            } else {
                $(selectors.$zendeskChat).addClass('is_hidden').hide();
            }
        }

        function close() {
            selectors.$closeButton.click(function(event){
                event.stopPropagation();
                hidePopup();
            });
        }

        function sendMessage() {
            selectors.$sendButton.click(hidePopup);
            selectors.$chatBubble.click(hidePopup);
        }

        function hidePopup() {
            selectors.$container.hide();
            selectors.$chatBubble.show();
            $(selectors.$zendeskChat).hide();
            setSessionStorage(sessionKey, true);
        }
      
      	function iOS() {
          return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
          ].includes(navigator.platform)
        }
      	
       var checkdevice = iOS();
       console.log(checkdevice);

        function showPopup() {
          if(checkdevice == true){
          	if (getSessionStorage(sessionKey)) {
              	setTimeout(function(){
                  selectors.$container.hide();
                  selectors.$chatBubble.show();
				},3000);
            } else {
                setTimeout(function(){
                selectors.$container.show();
                selectors.$chatBubble.hide();
              },3000);
            }
          }
        }

        function setSessionStorage(key, value) {
            sessionStorage.setItem(key, value);
        }

        function getSessionStorage(key){
            return sessionStorage.getItem(key);
        }

        function isTimePeriodMatched(){
            var today = new Date();
            var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
            var startTime = '09:00:00';
            var endTime = '18:59:59';
            var startDate = date+' '+startTime;
            var endDate = date+' '+endTime;
            var fullStartDate = new Date(startDate);
            var fullEndDate = new Date(endDate);
            var now = Date.now();
            let startDateArray = startDate.split(/[- :]/);
            let endDateArray = endDate.split(/[- :]/);

            fullStartDate = new Date(startDateArray[0], startDateArray[1]-1, startDateArray[2], startDateArray[3], startDateArray[4], startDateArray[5]);
            fullEndDate = new Date(endDateArray[0], endDateArray[1]-1, endDateArray[2], endDateArray[3], endDateArray[4], endDateArray[5]);
            fullStartDate = new Date(fullStartDate).getTime();
            fullEndDate = new Date(fullEndDate).getTime();

            return ((fullStartDate < now) && (fullEndDate > now));
        }

        return {
            init: init,
            isTimePeriodMatched: isTimePeriodMatched
        }
    })();
    
    if ($(window).width() < 992 && $('.page-quote').length == 0) {
        IOSChat.setup.init();
    }

    if ($('.page-quote').length != 0) {
        if ($(window).width() < 992 && !isIOSDevice()) {
            $('.bubble_chat_ios').hide();
        }
    }

    /** skeleton loading effect */
    window.Skeleton = window.Skeleton || {};
    Skeleton.setup = (function(){
        var classesToRemoved = ['skeleton', 'skeleton_hidden'];
        var ajaxContainer = $('[data-ajax-load="isAjaxLoad"]');

        function contentIsReadyToDisplay(){
            classesToRemoved.forEach(function(value){
                $(`.${value}`).removeClass(value);
            });
        }

        window.addEventListener("load", () => {
            if (ajaxContainer.length === 0) {
                contentIsReadyToDisplay();
            }
        });
    })();

    

    function isIOSDevice() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }
});

